import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {AssessmentService} from '../../../services/assessment.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-banner-pagina-show',
  templateUrl: './banner.component.html',
  styleUrls: ['../../userpanel.component.css'],
  providers: [AssessmentService]
})
export class BannerPaginaComponent implements OnInit {

  @Input()
  public dataBanner: any;
  @Input()
  public percentage: any;

  constructor(private _router: Router, private _assessmentService: AssessmentService) {
  }

  ngOnInit() {
    this.showModal();
  }

  public checkIfNeedToShowBanner(): boolean {
    return (this.dataBanner.data[0] && this.dataBanner.data[0].status === 0);
  }

  public showModal(): void {

    if (this.checkIfNeedToShowBanner()) {
      const banner = this.dataBanner.data[0].value.banner;
      if ((banner.trilha.posicao === 'final' && this.percentage === 100) || (banner.trilha.posicao === 'inicial')) {
        this.sendFeedBack();
        this.modal(banner);
      }
    }
  }

  private sendFeedBack(): void {
    this._assessmentService.postConfirmAssessment(this.dataBanner.data[0].id)
      .subscribe(res => {
        // sei la
      });
  }

  public modal(data: any) {
    const _this = this;
    Swal.fire({
      imageUrl: environment.baseUrl + data.imagem,
      imageWidth: 800,
      imageHeight: 518,
      // showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      confirmButtonText: 'Assessment',
      cancelButtonText: 'Não, obrigado.',
      cancelButtonClass: 'btn btn-danger',
      imageAlt: 'Assessment',
      animation: true
    }).then((result) => {
      if (result.value) {
        _this._router.navigate(['/visualizador/assessment/', _this.dataBanner.data[0].assessment_id]);            
      }
       
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/listagem-cursos-pagina/banner/banner.component.ts